import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaCheckCircle, FaTimesCircle, FaSun, FaMoon } from 'react-icons/fa';

export default function PaymentResult() {
  const location = useLocation();
  const navigate = useNavigate();
  const [dark, setDark] = useState(true);

  const queryParams = new URLSearchParams(location.search);
  const success = queryParams.get('success').toLowerCase() === 'true';
  const planId = queryParams.get('planId');

  return (
    <div className={dark ? 'dark' : ''}>
      <div className="min-h-screen flex items-center justify-center bg-gray-100 dark:bg-[#0e1015] text-black dark:text-white px-4 font-vazir relative">
        <div className="bg-white dark:bg-[#1a1d2e] p-6 rounded-xl shadow max-w-md w-full text-center z-10">
          {success ? (
            <>
              <FaCheckCircle className="text-green-500 text-4xl mx-auto mb-4" />
              <h1 className="text-xl font-bold mb-2">پرداخت با موفقیت انجام شد</h1>
              <p className="text-sm text-gray-500 mb-4">
                برنامه‌ی شما در حال آماده‌سازی است و طی چند ساعت آینده از طریق پیامک اطلاع‌رسانی خواهد شد.
              </p>
              <button
                onClick={() => navigate('/')}
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-xl mt-4"
              >
                بازگشت به صفحه اصلی
              </button>
            </>
          ) : (
            <>
              <FaTimesCircle className="text-red-500 text-4xl mx-auto mb-4" />
              <h1 className="text-xl font-bold mb-2">پرداخت ناموفق بود</h1>
              <p className="text-sm text-gray-500 mb-4">لطفاً دوباره تلاش کنید.</p>
              <button
                onClick={() => {
                  localStorage.setItem('planId', planId);
                  navigate('/payment');
                }}
                className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded-xl mt-4"
              >
                بازگشت به پرداخت
              </button>
            </>
          )}
        </div>

        {/* کلید روشن/تیره */}
        <button
          onClick={() => setDark(!dark)}
          className="fixed top-4 right-4 z-50 px-3 py-2 bg-gray-700 text-white rounded-full shadow-lg"
        >
          {dark ? <FaSun className="text-yellow-400" /> : <FaMoon className="text-blue-500" />}
        </button>
      </div>
    </div>
  );
}
